import {RoomClientState} from '../../../../shared/scripts/RoomClientState.ts'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import {UIRoomUserList} from '../../../../shared/scripts/ui_html/room/UIRoomUserList'
import {RoomSessionClientState} from '../../../../shared/scripts/RoomSessionClientState.ts'
import {ViewPopupEditProfile, EditProfileTab} from '../../../../shared/scripts/ui_popup/ViewPopupEditProfile'
import {PlayerColor} from '@colonist/game-states'
import {UIWProfileUsernameController} from '../header/UIWProfileUsernameController'
import {ViewPopupEditBotProfile} from '../../../../shared/scripts/ui_popup/ViewPopupEditBotProfile'
import {socket} from '../../../../shared/scripts/EntryShared.ts'

export class UIWRoomUserListController extends UIRoomUserList {
    private readonly header: HTMLHeadingElement

    constructor() {
        super(document.getElementById('scene_room_player_list') as HTMLDivElement)
        this.header = document.getElementById('scene_room_left_header') as HTMLHeadingElement
    }

    update(newRoomState: RoomClientState) {
        this.updateHeaderView(newRoomState.getSessionCount(), newRoomState.gameSetting.maxPlayers)
        super.update(newRoomState)
    }

    private updateHeaderView(sessionCount: number, maxPlayers: number) {
        const newText = clientI18n.t('strings:roomPage.notifications.playerCount', {count: sessionCount, maxCount: maxPlayers})
        if(this.header.innerText != newText) this.header.innerText = newText
    }

    // eslint-disable-next-line class-methods-use-this
    protected openEditProfileForPlayer(player: RoomSessionClientState | undefined): void {
        if(player?.isBot) {
            new ViewPopupEditBotProfile({
                usernameController: UIWProfileUsernameController,
                selectColorAction: async(color: PlayerColor) => {
                    if(player == undefined) return
                    socket.roomClient.selectColor(player.roomSessionId, color)
                },
                tab: EditProfileTab.Color,
                selectedColor: player?.selectedColor,
                username: player?.username,
            })
            return
        }

        new ViewPopupEditProfile({
            usernameController: UIWProfileUsernameController,
            selectColorAction: async(color: PlayerColor) => {
                if(player == undefined) return
                socket.roomClient.selectColor(player.roomSessionId, color)
            },
            tab: EditProfileTab.Color,
            selectedColor: player?.selectedColor,
        })
    }
}
